// extracted by mini-css-extract-plugin
export default {"wrapper":"AccordionBtnV1_wrapper__ofbfJ","accordion":"AccordionBtnV1_accordion__sboz+","icon":"AccordionBtnV1_icon__57GUJ","panel":"AccordionBtnV1_panel__Yh-O5"};